<script setup lang="ts">
import {useAttrs, useTemplateRef} from "vue";
import Drawer from "primevue/drawer";
import {useSwipe} from "@vueuse/core";

const attrs = useAttrs();
const model = defineModel("visible");
const content = useTemplateRef("content");
const {isSwiping, direction, lengthX, lengthY} = useSwipe(content, {
    onSwipe(e: TouchEvent) {
        if (
            (direction.value === "right" && attrs.position === "right") ||
            (direction.value === "left" && attrs.position === "left") ||
            (direction.value === "down" &&
                attrs.position === "bottom" &&
                content.value.scrollTop < 50 &&
                lengthY.value < -50) ||
            (direction.value === "up" && attrs.position === "top" && lengthY.value > 50)
        ) {
            model.value = false;
        }
    },
});
</script>
<template>
    <Drawer v-bind="$attrs" v-model:visible="model" class="overscroll-none overscroll-y-contain">
        <template #header>
            <slot name="header"></slot>
        </template>
        <div
            ref="content"
            class="h-full max-h-full w-full grow overflow-y-auto overscroll-none overscroll-y-contain px-3 py-3 pt-0 lg:px-4"
        >
            <slot></slot>
        </div>
    </Drawer>
</template>
<style scoped></style>
